import { validPropDroplistTextVM } from '../../../../core/components/validation/ValidInputDroplistText';
import { validPropDateVM } from '../../../../core/components/validation/ValidInputDate';
import { validOptionalPropTextVM } from '../../../../core/components/validation/ValidInputText';
import { getDateRangeForMode } from '../../../../core/components/validation/ValidInputDate.utils';
import { SplitOrderInvoicesSearchModel } from './split_order_invoices_search_types';
import { ValidOption } from '../../../../core/components/validation/types';

const DEFAULT_DATE_RANGE_MODE = 'MTD';

export function splitOrderInvoicesSearchStateVM(_data: any = {}): SplitOrderInvoicesSearchModel {
    const data = _data ?? {};
    const rxOptions: ValidOption[] = data.rxOptions ?? [];
    const ceOptions: ValidOption[] = data.ceOptions ?? [];

    // DateRangeMode may arrive as a plain string (fresh init) or a ValidProp object (saved viewstate).
    const dateRangeMode =
        (typeof data.DateRangeMode === 'string' ? data.DateRangeMode : data.DateRangeMode?.val) ||
        DEFAULT_DATE_RANGE_MODE;
    const defaultRange = getDateRangeForMode(DEFAULT_DATE_RANGE_MODE);

    return {
        RX: validPropDroplistTextVM('RX', 'Pharmacy', data.RX?.val ?? '', 'Select Pharmacy', rxOptions),
        CE: validPropDroplistTextVM('CE', 'Facility', data.CE?.val ?? 'ALL', 'ALL', ceOptions),
        StartDate: validPropDateVM('StartDate', 'Start Date', data.StartDate?.val ?? defaultRange.start),
        EndDate: validPropDateVM('EndDate', 'End Date', data.EndDate?.val ?? defaultRange.end),
        DateRangeMode: validOptionalPropTextVM('DateRangeMode', 'Date Range Mode', dateRangeMode, '', false),
        RebatesOnly: data.RebatesOnly ?? false,
    };
}
